import * as React from 'react';
import styled from 'styled-components';
import { SvgLoading } from '../..';
import { Translate } from '../../../Translate';
import { DSButtonProps, DSButton } from '../DSButton';

const StyledButton = styled(DSButton)<{ $gutterTop?: boolean }>`
    ${props => props.$gutterTop && `margin-top: ${props.theme.spacing(1)}px;`}
`;

export type DSLoadMoreButtonProps = Pick<DSButtonProps, 'children' | 'disabled' | 'onClick'> & {
    gutterTop?: boolean;
    loading?: boolean;
    children?: React.ReactNode;
};

export function DSLoadMoreButton({
    children,
    disabled,
    gutterTop,
    loading,
    ...props
}: DSLoadMoreButtonProps): JSX.Element {
    return (
        <StyledButton
            $gutterTop={gutterTop}
            color="primary"
            disabled={disabled || loading}
            variant="outlined"
            {...props}
        >
            {children ? children : <>{loading ? <SvgLoading /> : <Translate keyId="COMMON.LOAD_MORE" />}</>}
        </StyledButton>
    );
}
DSLoadMoreButton.displayName = 'DSLoadMoreButton';
